import colors from './colors';

const branding = {
    primary: {
        main: colors.green.primary,
        light: colors.green['300'],
        dark: colors.green['600'],
        darker: colors.green['700'],
    },
    secondary: {
        main: colors.blue.primary,
        light: colors.blue['300'],
        dark: colors.blue['600'],
        darker: colors.blue['700'],
    },
    tertiary: {
        main: colors.red.primary,
        light: colors.red['300'],
        dark: colors.red['600'],
        darker: colors.red['700'],
    },
    quaternary: {
        main: colors.yellow.primary,
        light: colors.yellow['300'],
        dark: colors.yellow['700'],
        darker: colors.yellow['700'],
    },
    /**
        quinary (5)
        senary (6)
        septenary (7)
        octonary (8)
        nonary (9)
        denary (10)
    */
    text: {
        main: colors.text.primary,
        light: colors.text['50'],
        dark: colors.text['900'],
    },
    white: {
        main: colors.white.primary,
        lighter: colors.white['50'],
        dark: colors.white['800'],
        darker: colors.white['900'],
    },
    gray: {
        main: colors.gray.primary,
        lighter: colors.gray['50'],
        light: colors.gray['300'],
        dark: colors.gray['800'],
        darker: colors.gray['900'],
    },
};

export default branding;
